import React, { useState } from 'react';
import './MemoryCard.css';

function MemoryCard({ memory }) {
  const [open, setOpen] = useState(false);
  const date = new Date(memory.created_at).toLocaleDateString('ko-KR', { year: 'numeric', month: 'short', day: 'numeric' });

  return (
    <>
      <div className="memory-card" onClick={() => setOpen(true)}>
        <div className="memory-card__img-wrap">
          <img src={memory.url} alt="memory" />
          <div className="memory-card__overlay">
            <span className="memory-card__date">{date}</span>
          </div>
        </div>
      </div>

      {open && (
        <div className="memory-lightbox" onClick={() => setOpen(false)}>
          <button className="memory-lightbox__close" onClick={() => setOpen(false)}>✕</button>
          <img src={memory.url} alt="memory" onClick={e => e.stopPropagation()} />
          <p className="memory-lightbox__date">{date}</p>
        </div>
      )}
    </>
  );
}

export default MemoryCard;
